import graphqlFilterOperatorAliases from './graphqlFilterOperatorAliases.js';
import normalizeGraphqlName from './normalizeGraphqlName.js';

const normalizeOperatorToken = (token) => {
  const normalized = normalizeGraphqlName(token);
  const operatorEntry = Object.entries(graphqlFilterOperatorAliases).find(([, aliases]) => aliases.some((alias) => normalizeGraphqlName(alias) === normalized));

  if (!operatorEntry) {
    return null;
  }

  return operatorEntry[0];
};

export default normalizeOperatorToken;
